import Button from "../components/ui/Button";
import { useState, useEffect } from "react";
import StrokeTitle from "../components/ui/StrokeTitle";
import CharacterModal from "../components/ui/CharacterModal";
import { useLocation } from "react-router-dom";
import '../styles/pages/characters.scss'
import FlowerTitle from "../components/ui/FlowerTitle";


const Characters = () => {

  
  const [page, setPage] = useState("main")

  return (
    <div className="page-container">
      
      <FlowerTitle text="Characters"/>
      <nav className="page-nav">
        <Button text="Main Characters" color="green" onClick={()=>setPage("main")}/>
        <Button text="Other Characters" color="blue" onClick={()=>setPage("other")}/>
      </nav>
      {
        page === "main" ? <MainCharacters/> : <OtherCharacters/>
      }
      <nav className="page-nav">
        <Button text="Main Characters" color="green" onClick={()=>setPage("main")}/>
        <Button text="Other Characters" color="blue" onClick={()=>setPage("other")}/>
      </nav>
    </div>
  )
}

const MainCharacters = () => {

  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 6
  });

  const [modal2, setModal2] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 2
  });

  const location = useLocation();
  
  useEffect(() => {    
      // Get the hash without the # symbol
      const hash = location.hash.slice(1);
      
      // Only run character-specific code if there's a hash
      if (hash) {
        console.log(`Character selected: ${hash}`);
        
        // Add your character-specific code here based on the hash
        switch(hash) {
          case 'fuji':
            setModal({
              ...modal,
              'visible': true,
              'current': 0,
            })
            break;
          case 'pirilika':
            setModal({
              ...modal,
              'visible': true,
              'current': 1,
            })
            break;
            case 'ao':
            setModal({
              ...modal,
              'visible': true,
              'current': 2,
            })
            break;
            case 'yeyasu':
            setModal({
              ...modal,
              'visible': true,
              'current': 3,
            })
            break;
            case 'ceefore':
            setModal({
              ...modal,
              'visible': true,
              'current': 4,
            })
            break;
            case 'suisen':
            setModal({
              ...modal,
              'visible': true,
              'current': 5,
            })
            break;
            case 'higan':
            setModal({
              ...modal,
              'visible': true,
              'current': 6,
            })
            break;
          default:
        }
      }
  },[]); // Re-run whenever the URL changes
  
  return (
    <>
      <CharacterModal modal={modal} setModal={setModal} url="img_main_.png" characters={mainCharacters}/>
      <StrokeTitle text="Main Characters"/>
      <div className="character-list">
      {
        mainCharacters.map((char, index)=>(
          <div className="character-button">
            <img src={`${process.env.PUBLIC_URL}/img/characters/icon_main_0${index+1}.png`} alt="" className="character-icon" 
              onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': index,
                  }
                )
              }}
            />
          </div>
        ))
      }
      </div>

      <CharacterModal modal={modal2} setModal={setModal2} url="img_sub_.png" characters={otherCharacters}/>
      <StrokeTitle text="Side Characters"/>
      <div className="character-list">
      {
        otherCharacters.map((char, index)=>(
          <div className="character-button">
            <img src={`${process.env.PUBLIC_URL}/img/characters/icon_sub_0${index+1}.png`} alt="" className="character-icon" 
              onClick={()=>{
                setModal2(
                  {
                    ...modal2,
                    'visible': true,
                    'current': index,
                  }
                )
              }}
            />
          </div>
        ))
      }
      </div>
    </>
  )
}

const OtherCharacters = () => {

  const [modal, setModal] = useState({
    visible: false,
    current: 1,
    url: "",
    size: 44
  });
  
  return (
    <>
      <CharacterModal modal={modal} setModal={setModal} url="img_generic_.png" characters={genericCharacters}/>
      <StrokeTitle text="Generic Characters"/>
      <div className="character-list">
      {
        genericCharacters.map((char, index)=>(
          <div className="character-button">
            <img src={`${process.env.PUBLIC_URL}/img/characters/icon_generic_${index < 9 ? "0"+(index+1) : (index+1)}.png`} alt="" className="character-icon" 
              onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': index,
                  }
                )
              }}
            />
            <h2>
              
            </h2>
          </div>
        ))
      }
      </div>
    </>
  )
}

const mainCharacters = [
  {
    name: "Fuji",
    desc: "Empathy-Averse Warrior Gone Astray",
    para: `A quintessentially demonic demon who possesses all three qualities of brutality, frugality, and laziness. He’ll do anything to win in battle, and lives by the motto "winners are heroes; losers are zeroes." He claims to be allergic to empathy, and reacts to love, friendship, or sympathy by vomiting blood and passing out.`,
    catch: `I’m gonna do my worst!`
  },
  {
    name: "Pirilika",
    desc: "Hinomoto Otaku with a Heart of Gold",
    para: `A klutzy, rich, and spoiled girl from the Netherworld of Wahei. She’s hopelessley obsessed with the Hinomoto Netherworlds, often misusing bushido in an attempt to get others on her side, and firmly believes in the goodness of others, no matter how evil they might be!`,
    catch: `Oh! I’ve heard about this traditional Hinomoto dance! The On-the-Knees Grovel!`
  },
  {
    name: "Ao",
    desc: "Fuji’s Wild Child",
    para: `A young girl who fondly calls Fuji her "dad." She may be obsessed with Fuji, but she’ll beat anyone else to a pulp with her impressive strength.`,
    catch: `And now you’re gonna give Ao a nice biiig hug, right? Ao loves you sooo much...Dad♥`
  },
  {
    name: "Yeyasu",
    desc: "Degenerate Shogun",
    para: `Hinomoto’s puppet shogun, and a complete good-for-nothing, narcissistic coward. He loves the ladies, and throws parties every day. While he may just be a puppet, he does have the privilege of wielding the Demonic Staff, Tokugawa Tenge, one of the Seven Founding Weapons.`,
    catch: `Uh-hyahyahya! Aw, yeah! Aw, yeah! C’mon, take a look at my swag!`
  },
  {
    name: "Ceefore",
    desc: "Chivalrous Thief Who Loves Explosives",
    para: `Known across Hinomoto as the Chivalric Thief, Mouse☆Girl. She’s obsessed with weapons, explosions, and sniffing gunpowder, which if she goes too long without doing, negatively affects her health. She’s apparently collecting Infernal Treasures for "research purposes"...`,
    catch: `Fififi! I love the energy here! Man, I’m super pumped up right now!`
  },
  {
    name: "Suisen",
    desc: "Living Weapon that Predicts the Future",
    para: `The young Forseeing Magistrate is a prominent member of the shogunate. He may look youthful, but he is highly capable in battle, collecting data with his cybernetic enhancements which he uses to predict the future. He usually speaks in a cold, robotic manner, but he sometimes speaks just like a normal little boy.`,
    catch: `I, Suisen the Foreseeing Magistrate, will annihilate you all, as ordered.`
  },
  {
    name: "Higan Zesshosai",
    desc: "Swordmaster Who’s Bored of Swords",
    para: `The inheritor of the Zesshosai title, marking her as the strongest swordmaster in all of Hinomoto. She is Fuji’s old master, and according to him, she’s the strongest, nastiest, most sinister, most evil swordfighter ever. She currently wields a spear to give everyone else a fair shot in battle, since she’s too strong with a sword.`,
    catch: `My name is Higan Zesshosai... Those who get in my way will meet death!`
  }
]

const otherCharacters = [
  {
    name: "Pii-chan",
    para: `Pirilika’s personal secretary, who has served her since she was a child. He is an excellent personal assistant, but is all about business and can be a little standoffish...to the point where he sometimes abandons Pirilika when she’s in a tight spot.`,
  },
  {
    name: "Nitra",
    para: `A well-mannered angel who was rescued by Fuji while being attacked by the shogunate. Why is an angel like her in the Netherworld? What is she after? There are many mysteries surrounding her actions...`,
  },
  {
    name: "Demmodore Opener",
    para: `Leader of the Netherarmy, an army of well-trained demons. He rules over the Hinomoto Netherworlds, and has warped their traditional views of bushido. Opener wields the Demonic Fist, one of the Seven Founding Weapons, using his almighty power to maintain control over his warriors.`,
  }
]

const genericCharacters = [{
    desc: "Peerless Dancer, Symbolic of Hinomoto",
    name: "Maiko",
    para: `The Maiko charms enemies with her graceful dancing. This temptress has all sorts of abilities, including increasing damage dealt to male enemies. Her charm and elegance has made her popular off the battlefield, too.`},
{
    desc: "Never Far from Treasure",
    name:"Bandit",
    para: `This young boy excels at treasure hunting. Even run-of-the-mill Treasure Chests will produce rare items when the Bandit is involved! He aspires to be even better than his father.`},
{
    desc: "Fiery and Determined",
    name:"Warrior",
    para: `A strong warrior with an unrelenting spirit. Displays his strength in adverse situations. Enjoys weight training, and is highly confident in his muscles.`},
{
    desc: "Fleet Frontline Fighter",
    name: "Valkyrie",
    para: `A strong and agile female warrior. Specializes in lightning-quick strikes to break through enemy lines. Loves muscles, but is like any other teen girl.`
},
{
    desc: "Being Surrounded Just Means More Counter-Attacks",
    name:"Martial Artist",
    para: `A martial artist without equal. Uses powerful counter-attacks in battle. His unique fashion pays homage to the original master of his art.`},
{
    desc: "Adaptive Combat Control",
    name:"Fight Mistress",
    para: `The Fight Mistress fights with a flourish. She specializes in parrying enemy attacks. Apparently, she comes from somewhere even more rural than Hinomoto.`},
{
    desc: "Master of Fiery Destruction",
    name:"Magician",
    para: `A sincere, young spellcaster. He weaponizes his considerable magical ability into powerful attacks. He has a skull on his headgear, but avoids wearing it over his face because of the odd looks he gets when he does.`},
{
    desc: "Area Attacks with Unbeatable Cost-Performance",
    name:"Witch",
    para: `An innocent witch girl. She has weak shoulders, but uses magic effectively. Her trademark ribbon doubles as a magic receiver.`},
{
    desc: "A Healer Robed in Penance",
    name:"Clergy",
    para: `Considers healing to be a gravely sinful act. He punishes himself while healing. Simultaneously cures Status Ailments when healing.`},
{
    desc: "Savior of the Nearly-Dead",
    name:"Cleric",
    para: `A nun who heals injured allies. She always keeps her eyes shut, as she’s been trained to do. Unlike her male counterpart, she does not consider healing to be a sin.`},
{
    desc: "Curse-Wielding Mocker of Life and Death",
    name:"Sorcerer",
    para: `A witch doctor whose evil curses bring about misfortune. She worships Dolvalky, Deity of Despair and Unhappiness. She talks oddly to avoid accidentally cursing people.`},
{
    desc: "Master of Blades and Spells",
    name:"Magic Knight",
    para: `An unusual knight, who wields both swords and spells. Her loyalty is unwavering, despite her demonic heritage. She is said to possess a mysterious ability called "the Zone."`},
{
  desc: "Undead Prankster",
  name:"Zombie Maiden",
  para: `A demon resurrected from death. This cutie gets powered up when her teammates die, and can even resurrect, but has low intelligence. That could either be attributed to her youth or from having already died.`},
{
  desc: "Massive Pupil of Chaos",
  name: "Big Eye",
  para: `Highly respected by many demons, the Big Eye holds an esteemed position in the Netherworld. They change the enemies’ defense statuses at-will.`
},
{
  desc: "Lowest of the Low",
  name:"Prinny",
  para: `The most abundant kind of demon. He explodes when thrown. Inside each Prinny is the soul of a sinner, seeking atonement by performing grueling tasks. “Treat me well, dood!”`},
{
  desc: "Risen from the Grave",
  name:"Undead",
  para: `He heals while he attacks, making him very tough. His exceedingly low intelligence is due to his rotten brain.`},
{
  desc: "Specialist in Annoyance",
  name:"Winged Warrior",
  para: `An insect demon whose dust causes Status Ailments. Other demons avoid him due to his appearance.`},
{
  desc: "Ruler of the Skies",
  name:"Dragon",
  para: `His strength and pride sets him apart from average demons. Enduring attacks boosts his power.`},
{
  desc: "Elite Dragon Zombie Rider",
  name:"Horseman",
  para: `The embodiment of demonic pride. Their strong armor weakens physical attacks, and their resilience makes them perfect tanks.`},
{
  desc: "Watch Out for Her Hooves",
  name:"Evil Eye",
  para: `A bovine demon with cursing eyes. She’s timid, but has the power to crush others. She lowers her opponents’ defense power.`},
{
  desc: "Good Luck Charm",
  name:"Sea Angel",
  para: `Her species was created by water pollution. This tragic demon specializes in support. Along with boosting allies, she also boosts EXP gained.`},
{
  desc: "One-of-a-Kind Flower",
  name:"Flora Beast",
  para: `The upper half is human, the lower half is flower. She uses aromatherapy and good looks to offer soothing support to her allies.`},
{
  desc: "Men Are So Useless",
  name:"Succubus",
  para: `A demonic beauty who tempts men. She weakens men by stealing their hearts. Felynns are just about the only other species they get along with.`},
{
  desc: "Feisty Feline Brawler",
  name:"Felynn",
  para: `A tomboy catgirl adept at martial arts. She uses counters and flurries of attacks to overwhelm her enemies.`},
{
    desc: "Proud, yet Suffering",
    name:"Male Samurai",
    para: `A warrior with his own code and pride, who follows his bushido. Still, there are too many who struggle to abide by their principles in this day and age...`},
{
    desc: "A Blade to Purge Evil",
    name:"Lady Samurai",
    para: `A female warrior who works outside of Hinomoto. She excels at duels.`},
{
    desc: "Worried About Getting Noticed",
    name:"Ninja",
    para: `An assassin who dwells in darkness. He is highly mobile, operating freely across any battlefield.`},
{
    desc: "A Villain with a Pure Heart",
    name:"Kunoichi",
    para: `Her honed techniques make her skilled at evasion. She has a youthful side that yearns for more stylish outfits.`},
{
    desc: "Cool as an Evil Cucumber",
    name:'Ranger',
    para: `A calm archer, indifferent to his work. He doesn’t get along with female archers, and has a disdain for the flat-chested.`},
{
    desc: "Bows--the Ultimate Weapon",
    name:"Archer",
    para: `A very earnest and kind hearted archer. She excels at ranged combat with a bow. Her chest gets flatter over the years, so as not to hinder her use with the bow.`},
{
    desc: "Proud, but Worried About Screentime",
    name:"Gunner",
    para: `A fast and accurate gunfighter. He always hits what he aims at.`},
{
    desc: "Hungry for Money",
    name:"Gunslinger",
    para: `A gunfighter with a strong personality and speech mannerisms. She specializes in team attacks.`},
{
    desc: "Popular with the Kids",
    name:'Male Armor Knight',
    para: `A knight devoted to protection. His strength and gallantry make him popular with kids.`},
{
    desc: "The Unrelenting Hero’s Shield",
    name:"Female Armor Knight",
    para: `A stalwart defensive fighter. Recently, more women have wanted to become armor knights.`},
{
    desc: "A Fusion of Sorcery and Science",
    name:"Mecha Girl",
    para: `A robot born of magic and science. She is popular due to her high-performance capabilities, even in Celestia.`},
{
    desc: "The Saving Grace of Angels",
    name:"Celestial Hostess",
    para: `Many residents of Celestia are unyielding, but the Celestial Hostess is more open-minded. She can reduce the damage taken by nearby allies.`
},
{
  desc: "Loves Chaos and Destruction",
  name:"Rifle Demon",
  para: `A bizarre demon with a gun for an arm. He loves chaos and destruction, and will even undergo physical modifications in pursuit of chaos.`},
{
  desc: "A Gentleman with a Splendid Shell",
  name:"Pincer Shell",
  para: `He believes "shells make the demon." His defense power increases when he’s attacked.`},
{
  desc: "A Mysterious Cat-Like Creature",
  name:"Slumber Cat",
  para: `She turns on the charm to lower her enemy’s guard. She’s always eyeing the spotlight. She’s strong against attacks from humanoids.`},
{
  desc: "The True Mascot",
  name:"Shroom",
  para: `A mushroom that loves damp places. Apparently he isn’t from the Netherworld, but hails from Marl’s Kingdom instead. He lowers the stats of nearby female units.`},
  {
    desc: "A Boy Whose Powers Have Awakened",
    name:"Psychic",
    para: `Manipulates enemies, reducing their mobility, and uses other unorthodox tactics. He can also teleport to maintain the upper hand.`},
  {
    desc: "Always Needs New Test Subjects",
    name:'Professor',
    para: `A demonic scientist, always quick to begin live experiments. She has a good reputation, since allies benefit from her tests...for the most part.`},
{
    desc: "Stealing Victory",
    name:"Thief",
    para: `A thief who gives her all at treasure hunting. While she steals mainly for fun, she also takes pride in her skills.`},
{
    desc: "A Ghostly Prankster",
    name:"Spirit",
    para: `Adept at using dangerous magic. Don’t let his cute looks fool you. Removing his cloak will also take away his personality, thus angering him.`},
{
    desc: "Rambunctious Hooligan",
    name:"Orc",
    para: `He may look puny, but he’s brave enough to take on giants. He gains a stat boost from having allies nearby.`
},
{
  desc: "Rambunctious Hooligan",
  name:"Orc",
  para: `He may look puny, but he’s brave enough to take on giants. He gains a stat boost from having allies nearby.`
}
]

export default Characters;